import React, { useState } from 'react';

const APIReference = () => {
  const [expandedGroup, setExpandedGroup] = useState('auth');
  const [searchTerm, setSearchTerm] = useState('');

  const apiGroups = [
    {
      id: 'auth',
      name: 'Authentication',
      color: '#EF4444',
      endpoints: [
        { method: 'POST', path: '/api/v1/login', auth: 'None', desc: 'User login with username/password', body: '{username, password}', response: '{token, user, entities[]}' },
        { method: 'POST', path: '/api/v1/auth/logout', auth: 'JWT', desc: 'Logout and invalidate session', body: 'None', response: '{message}' },
        { method: 'GET', path: '/api/v1/profile', auth: 'JWT', desc: 'Get current user profile', body: 'None', response: '{user}' },
        { method: 'POST', path: '/api/v1/change-password', auth: 'JWT', desc: 'Change password (requires old password)', body: '{old_password, new_password}', response: '{message}' },
        { method: 'PUT', path: '/api/v1/ui-mode', auth: 'JWT', desc: 'Update UI mode preference', body: '{ui_mode: "classic"|"modern"}', response: '{message, ui_mode}' },
      ]
    },
    {
      id: 'sms',
      name: 'SMS Submission',
      color: '#10B981',
      endpoints: [
        { method: 'POST', path: '/api/v1/send-sms', auth: 'JWT', desc: 'Send SMS via GUI (single or bulk)', body: '{to, message, entity_id, header_id, template_id, ...}', response: '{message_id, status}' },
        { method: 'POST', path: '/api/v1/sendsms', auth: 'API Key', desc: 'Send SMS via HTTP API (POST)', body: '{to, message, entity_id, header_id, template_id, pe_id, tm_id}', response: '{message_id, status}' },
        { method: 'GET', path: '/api/v1/sms/send', auth: 'API Key', desc: 'Send SMS via HTTP API (GET query params)', body: 'Query: key, to, msg, entity_id, header_id, template_id', response: '{message_id, status}' },
      ]
    },
    {
      id: 'users',
      name: 'User Management',
      color: '#3B82F6',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/users', auth: 'JWT+Admin', desc: 'List all users with pagination', body: 'Query: page, limit, search', response: '{users[], total, page}' },
        { method: 'GET', path: '/api/v1/admin/users/:id', auth: 'JWT+Admin', desc: 'Get single user details', body: 'None', response: '{user}' },
        { method: 'POST', path: '/api/v1/admin/users', auth: 'JWT+Admin', desc: 'Create new user', body: '{username, email, password, role, ...}', response: '{user, id}' },
        { method: 'PUT', path: '/api/v1/admin/users/:id', auth: 'JWT+Admin', desc: 'Update user details', body: '{username, email, role, is_active, ...}', response: '{message}' },
        { method: 'DELETE', path: '/api/v1/admin/users/:id', auth: 'JWT+Admin', desc: 'Soft delete user', body: 'None', response: '{message}' },
        { method: 'POST', path: '/api/v1/admin/users/:id/regenerate-api-key', auth: 'JWT+Admin', desc: 'Regenerate user API key', body: 'None', response: '{api_key}' },
      ]
    },
    {
      id: 'dlt',
      name: 'DLT Management',
      color: '#F59E0B',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/entities', auth: 'JWT+Admin', desc: 'List DLT entities with pagination', body: 'Query: page, limit', response: '{entities[], total}' },
        { method: 'POST', path: '/api/v1/admin/entities', auth: 'JWT+Admin', desc: 'Create DLT entity', body: '{entity_name, entity_id}', response: '{entity}' },
        { method: 'GET', path: '/api/v1/admin/headers', auth: 'JWT+Admin', desc: 'List DLT headers', body: 'Query: page, limit, entity_id', response: '{headers[], total}' },
        { method: 'POST', path: '/api/v1/admin/headers', auth: 'JWT+Admin', desc: 'Create DLT header', body: '{entity_id, header_name, header_type}', response: '{header}' },
        { method: 'GET', path: '/api/v1/admin/templates', auth: 'JWT+Admin', desc: 'List DLT templates', body: 'Query: page, limit, entity_id', response: '{templates[], total}' },
        { method: 'POST', path: '/api/v1/admin/templates', auth: 'JWT+Admin', desc: 'Create DLT template', body: '{entity_id, header_id, template_id, template_name, template_content}', response: '{template}' },
        { method: 'PUT', path: '/api/v1/admin/templates/:id', auth: 'JWT+Admin', desc: 'Update DLT template', body: '{template_name, template_content, is_active}', response: '{message}' },
      ]
    },
    {
      id: 'plans',
      name: 'Plans & Subscriptions',
      color: '#8B5CF6',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/plans', auth: 'JWT+Admin', desc: 'List all plans', body: 'None', response: '{plans[]}' },
        { method: 'POST', path: '/api/v1/admin/plans', auth: 'JWT+Admin', desc: 'Create plan', body: '{plan_name, plan_type, rate_per_sms, ...}', response: '{plan}' },
        { method: 'PUT', path: '/api/v1/admin/plans/:id', auth: 'JWT+Admin', desc: 'Update plan', body: '{plan_name, rate_per_sms, is_active, ...}', response: '{message}' },
        { method: 'POST', path: '/api/v1/admin/user-plan-subscriptions', auth: 'JWT+Admin', desc: 'Subscribe user to plan', body: '{user_id, plan_id}', response: '{subscription}' },
      ]
    },
    {
      id: 'smpp',
      name: 'SMPP Management',
      color: '#06B6D4',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/smpp/connectors', auth: 'JWT+Master', desc: 'List SMPP connectors', body: 'None', response: '{connectors[]}' },
        { method: 'POST', path: '/api/v1/admin/smpp/connectors', auth: 'JWT+Master', desc: 'Create SMPP connector', body: '{connector_name, host, port, system_id, password, bind_type}', response: '{connector}' },
        { method: 'POST', path: '/api/v1/admin/smpp/connectors/:id/start', auth: 'JWT+Master', desc: 'Start SMPP connector', body: 'None', response: '{status}' },
        { method: 'POST', path: '/api/v1/admin/smpp/connectors/:id/stop', auth: 'JWT+Master', desc: 'Stop SMPP connector', body: 'None', response: '{status}' },
        { method: 'GET', path: '/api/v1/admin/smpp/connectors/:id/status', auth: 'JWT+Master', desc: 'Get connector status', body: 'None', response: '{connection_state, messages_sent_today, current_tps}' },
        { method: 'POST', path: '/api/v1/admin/smpp/connectors/:id/test', auth: 'JWT+Master', desc: 'Test SMPP connection', body: 'None', response: '{test_result}' },
      ]
    },
    {
      id: 'reports',
      name: 'Reports & Analytics',
      color: '#EC4899',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/reports/detailed', auth: 'JWT+Admin', desc: 'Detailed SMS reports with filters', body: 'Query: from, to, user_id, status, page, limit', response: '{reports[], total}' },
        { method: 'GET', path: '/api/v1/admin/reports/summary', auth: 'JWT+Admin', desc: 'Summary report (counts by status)', body: 'Query: from, to, user_id', response: '{summary}' },
        { method: 'GET', path: '/api/v1/admin/reports/dlr', auth: 'JWT+Admin', desc: 'DLR delivery reports', body: 'Query: from, to, message_id', response: '{dlr_reports[]}' },
        { method: 'GET', path: '/api/v1/admin/reports/monthly-sms', auth: 'JWT+Admin', desc: 'Monthly SMS summary per user', body: 'Query: month, user_id', response: '{monthly_data[]}' },
        { method: 'GET', path: '/api/v1/dashboard/counters', auth: 'JWT', desc: 'Dashboard KPI counters', body: 'None', response: '{total_sent, delivered, failed, balance}' },
      ]
    },
    {
      id: 'billing',
      name: 'Billing & Recharge',
      color: '#F97316',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/recharge', auth: 'JWT+Admin', desc: 'List recharge history', body: 'Query: page, limit, user_id', response: '{recharges[], total}' },
        { method: 'POST', path: '/api/v1/admin/recharge', auth: 'JWT+Admin', desc: 'Process recharge for user', body: '{user_id, amount, remarks}', response: '{transaction}' },
        { method: 'GET', path: '/api/v1/admin/balance-transactions', auth: 'JWT+Admin', desc: 'Balance transaction history', body: 'Query: user_id, from, to', response: '{transactions[]}' },
      ]
    },
    {
      id: 'routing',
      name: 'Routing Management',
      color: '#14B8A6',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/routes', auth: 'JWT+Admin', desc: 'List routing rules', body: 'None', response: '{routes[]}' },
        { method: 'POST', path: '/api/v1/admin/routes', auth: 'JWT+Admin', desc: 'Create routing rule', body: '{rule_type, rule_name, priority, conditions[], targets[]}', response: '{route}' },
        { method: 'PUT', path: '/api/v1/admin/routes/:id', auth: 'JWT+Admin', desc: 'Update routing rule', body: '{rule_name, priority, is_active}', response: '{message}' },
        { method: 'DELETE', path: '/api/v1/admin/routes/:id', auth: 'JWT+Admin', desc: 'Delete routing rule', body: 'None', response: '{message}' },
      ]
    },
    {
      id: 'workers',
      name: 'Worker Management',
      color: '#6366F1',
      endpoints: [
        { method: 'GET', path: '/api/v1/admin/workers', auth: 'JWT+Master', desc: 'List all workers and status', body: 'None', response: '{workers[]}' },
        { method: 'POST', path: '/api/v1/admin/workers/:code/start', auth: 'JWT+Master', desc: 'Start a worker', body: 'None', response: '{status}' },
        { method: 'POST', path: '/api/v1/admin/workers/:code/stop', auth: 'JWT+Master', desc: 'Stop a worker', body: 'None', response: '{status}' },
        { method: 'GET', path: '/api/v1/admin/workers/:code/logs', auth: 'JWT+Master', desc: 'Get worker logs', body: 'Query: limit, level', response: '{logs[]}' },
        { method: 'GET', path: '/api/v1/admin/workers/:code/config', auth: 'JWT+Master', desc: 'Get worker configuration', body: 'None', response: '{config}' },
      ]
    },
  ];

  const methodColors = {
    GET: { bg: '#DBEAFE', text: '#1D4ED8' },
    POST: { bg: '#D1FAE5', text: '#047857' },
    PUT: { bg: '#FEF3C7', text: '#B45309' },
    DELETE: { bg: '#FEE2E2', text: '#B91C1C' },
  };

  const filteredGroups = apiGroups.map(group => ({
    ...group,
    endpoints: group.endpoints.filter(ep =>
      !searchTerm ||
      ep.path.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ep.desc.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ep.method.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(g => g.endpoints.length > 0);

  const totalEndpoints = apiGroups.reduce((sum, g) => sum + g.endpoints.length, 0);

  return (
    <div className="max-w-7xl mx-auto">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          .print-break { page-break-before: always; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `}</style>

      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">API Reference</h1>
          <p className="mt-1 text-gray-600">{totalEndpoints} endpoints across {apiGroups.length} modules</p>
        </div>
        <div className="no-print flex gap-2">
          <button onClick={() => window.history.back()} className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-medium">← Back</button>
          <button onClick={() => window.print()} className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-medium">🖨️ Print</button>
        </div>
      </div>

      {/* Base URL */}
      <div className="bg-gray-900 rounded-xl p-4 mb-6 text-white">
        <div className="text-xs text-gray-400 mb-1">Base URL</div>
        <code className="text-sm text-green-400">https://mysmpp.in/api/v1</code>
        <div className="mt-2 flex gap-4 text-xs text-gray-400">
          <span>Auth: <code className="text-blue-400">Authorization: Bearer {'<jwt_token>'}</code></span>
          <span>API Key: <code className="text-blue-400">X-API-KEY: {'<api_key>'}</code></span>
        </div>
      </div>

      {/* Search */}
      <div className="no-print mb-6">
        <input
          type="text"
          placeholder="Search endpoints..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
        />
      </div>

      {/* API Groups */}
      {filteredGroups.map((group, gIdx) => (
        <div key={group.id} className={`mb-6 bg-white rounded-xl border border-gray-200 overflow-hidden ${gIdx > 3 ? 'print-break' : ''}`}>
          <button
            onClick={() => setExpandedGroup(expandedGroup === group.id ? null : group.id)}
            className="w-full px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
            style={{ borderLeft: `4px solid ${group.color}` }}
          >
            <div className="flex items-center gap-3">
              <h2 className="text-lg font-bold text-gray-900">{group.name}</h2>
              <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">{group.endpoints.length} endpoints</span>
            </div>
            <span className="text-gray-400 no-print">{expandedGroup === group.id ? '▼' : '▶'}</span>
          </button>

          <div className={`${expandedGroup === group.id || searchTerm ? 'block' : 'hidden'} print:!block`}>
            <div className="divide-y divide-gray-100">
              {group.endpoints.map((ep, i) => (
                <div key={i} className="px-5 py-3 hover:bg-gray-50">
                  <div className="flex items-center gap-3 mb-1">
                    <span
                      className="px-2 py-0.5 rounded text-xs font-bold min-w-[50px] text-center"
                      style={{ backgroundColor: methodColors[ep.method]?.bg, color: methodColors[ep.method]?.text }}
                    >
                      {ep.method}
                    </span>
                    <code className="text-sm font-mono text-gray-800">{ep.path}</code>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded ${ep.auth === 'None' ? 'bg-gray-100 text-gray-500' : ep.auth.includes('Master') ? 'bg-red-100 text-red-600' : ep.auth.includes('Admin') ? 'bg-purple-100 text-purple-600' : ep.auth === 'API Key' ? 'bg-amber-100 text-amber-600' : 'bg-blue-100 text-blue-600'}`}>
                      {ep.auth}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 ml-[62px]">{ep.desc}</p>
                  <div className="ml-[62px] mt-1 flex gap-4 text-xs text-gray-400">
                    <span>Body: <code className="text-gray-500">{ep.body}</code></span>
                    <span>Response: <code className="text-gray-500">{ep.response}</code></span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}

      {/* Auth Legend */}
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <h3 className="font-semibold text-gray-900 mb-3">Authentication Types</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { label: 'None', desc: 'Public endpoint (login only)', color: 'bg-gray-100 text-gray-600' },
            { label: 'JWT', desc: 'Any authenticated user', color: 'bg-blue-100 text-blue-600' },
            { label: 'JWT+Admin', desc: 'Admin or Master Admin role', color: 'bg-purple-100 text-purple-600' },
            { label: 'JWT+Master', desc: 'Master Admin only', color: 'bg-red-100 text-red-600' },
          ].map((auth, i) => (
            <div key={i} className="flex items-center gap-2">
              <span className={`text-xs px-2 py-0.5 rounded font-medium ${auth.color}`}>{auth.label}</span>
              <span className="text-xs text-gray-500">{auth.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default APIReference;
